import axios from 'axios';
import {backendHost} from '../../config';

export const putStatusTransactionById = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/transaction/status`, params);
};